import {Search} from "react-feather";
import React, {useEffect, useState} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import SearchDropdown from "../../input/SearchDropdown";
import {getBulkDropdownData, getOtherRefSearchDropdown, getTextByValueAndKey} from "../../../api/keyvalue";
import Dropdown from "../../input/Dropdown";
import Button from "../../input/Button";
import { searchStakeholderVehicleType} from "../../../api/stakeholderVehicleApi";
import {statusById} from "../../../const";
import useUserCompany from "../../../hooks/useUserCompany";
import {useSelector} from "react-redux";

const StakeholderVehicleTypeSearch = ({
                                      setStakeholderVehicleSearchRes,
                                      setStkVehSearchSubmitLoading,
                                      setStkVehSearchClicked,
                                      dropdown,
                                  }) => {

    const [activeAccordion1, setActiveAccordion1] = useState(true);
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const [resetVisible, setResetVisible] = useState(false);

    //search flags
    const [fieldReset, setFieldReset] = useState(false);

    //company
    const userCompany = useUserCompany();
    const [company, setCompany] = useState(
        userCompany ? userCompany.comId : null
    );
    useEffect(() => {
        setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    //author
    const user = useSelector((state) => state.user);


    //search states
    const [stakeholderType, setStakeholderType] = useState(1);
    const [stakeholder, setStakeholder] = useState(null);
    const [customerShipper, setCustomerShipper] = useState(null);
    const [vehicleType, setVehicleType] = useState(null);
    const [status, setStatus] = useState(null);
    const [active, setActive] = useState(null);
    const [selectedStakeholder, setSelectedStakeholder] = useState([]);

    const [stakeTypeOptions, setStakeTypeOptions] = useState([]);


    const handleReset = (e) => {
        e.preventDefault();
        setSearchFieldReset(true);
        setStatus(null);
        setActive(null);
    };

    useEffect(() => {
        (async () => {
            const selectedStakeholder = await getTextByValueAndKey(
                "stakeholder_type",
                stakeholderType
            );
            setSelectedStakeholder(selectedStakeholder);
        })();
    }, [stakeholderType]);

    const handleSearchSubmit = async (e) => {
        e.preventDefault();
        setActiveAccordion1(false);
        setResetVisible(true);
        setStkVehSearchSubmitLoading(true);
        setStkVehSearchClicked(true);

        const response = await searchStakeholderVehicleType({
            svtStakeholderType : stakeholderType,
            svtStakeholder : stakeholderType === 1 ? stakeholder : customerShipper,
            svtCustomerShipper: customerShipper,
            svtVehicleType : vehicleType,
            svtLoadingTime : null,
            svtUnloadingTime : null,
            stvStatus : status,
            stvActive : active,
            svtCompany : company,
            author : user.username
        });

        setStakeholderVehicleSearchRes(response);
        setStkVehSearchSubmitLoading(false);
    }

    const handleSearchReset = (e) =>{
        e.preventDefault();
        setStakeholderType(null);
        setStakeholder(null);
        setCustomerShipper(null);
        setVehicleType(null);
        setSearchFieldReset(true);
        setStatus(null);
        setActive(null);
    }
    useEffect(() => {
        (async () => {
            //new
            const {
                stakeholder_type: typeData,
            } = await getBulkDropdownData([
                { key: "stakeholder_type" },
            ]);
            const stkTypes = [1,2]
            const stakeholderTypeOpt = typeData.filter((typ) =>
                stkTypes.includes(typ.key)
            );
            setStakeTypeOptions(stakeholderTypeOpt);
        })();
    }, []);

    return(
        <>
            <div className="ui styled accordion" style={{width: "100%"}}>
                <div
                    className={`title ${activeAccordion1 ? "active" : ""}`}
                    onClick={() => setActiveAccordion1(!activeAccordion1)}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>
                            <span>Search</span>
                            <Search size={14} style={{marginLeft: "10px"}}/>
                            <i className="dropdown icon"></i>
                        </div>

                        <i
                            className="refresh icon primary button"
                            style={{
                                display: `${resetVisible ? "flex" : "none"}`,
                                cursor: "pointer",
                            }}
                            onClick={(e) => {
                                handleReset(e);
                            }}
                        ></i>
                    </div>
                </div>
                <div className={`content ${activeAccordion1 ? "active" : ""}`}>
                    {isSearchLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <form className="ui form">
                            <h4 className="ui dividing header"></h4>
                            <div className="five fields">

                                <Dropdown
                                    label="Stakeholder Type"
                                    placeholder="Stakeholder Type"
                                    options={stakeTypeOptions}
                                    value={stakeholderType}
                                    onChange={(e, data) => {
                                        setStakeholderType(data.value);
                                        setFieldReset(true);
                                        setStakeholder("");
                                        setCustomerShipper("");
                                    }}
                                />
                                {stakeholderType === 1?(
                                <SearchDropdown
                                    key={1}
                                    editMode={false}
                                    reset={fieldReset || searchFieldReset}
                                    setReset={setFieldReset || setSearchFieldReset}
                                    clearable={true}
                                    onClear={() => {
                                        setStakeholder("");
                                    }}
                                    onResultSelect={(data) => setStakeholder(data)}
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "stakeholder_type",
                                        value: selectedStakeholder,
                                    }}
                                    label="Stakeholder"
                                />
                                ):(
                                    <SearchDropdown
                                        key={1}
                                        editMode={false}
                                        reset={fieldReset || searchFieldReset}
                                        setReset={setFieldReset || setSearchFieldReset}
                                        clearable={true}
                                        onClear={() => {
                                            setCustomerShipper("");
                                        }}
                                        onResultSelect={(data) => setCustomerShipper(data)}
                                        api={getOtherRefSearchDropdown}
                                        apiDependency={{
                                            type: "stakeholder_type",
                                            value: "customer_shipper",
                                        }}
                                        label="Customer Shipper"
                                    />
                                )}

                                <SearchDropdown
                                    key={1}
                                    editMode={false}
                                    clearable={true}
                                    reset={searchFieldReset}
                                    setReset={setSearchFieldReset}
                                    onResultSelect={(data) => setVehicleType(data)}
                                    onClear={() => {
                                        setVehicleType(null);
                                    }}
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "vehicle_type",
                                        value: "",
                                    }}
                                    label="Vehicle Type"
                                />
                                <Dropdown
                                    label="Status"
                                    options={dropdown.statusOptions}
                                    placeholder="Status"
                                    style={{height: "20px"}}
                                    value={status}
                                    onChange={(e, data) => {
                                        setStatus(data.value);
                                    }}
                                />
                                <Dropdown
                                    label="Active"
                                    options={dropdown.activeOptions}
                                    placeholder="Active"
                                    style={{height: "20px"}}
                                    value={active}
                                    onChange={(e, data) => {
                                        setActive(data.value);
                                    }}
                                />
                            </div>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <div className="field" style={{width: "100%"}}>
                                    <Button
                                        template="search"
                                        onClick={(e) => {
                                            handleSearchSubmit(e);
                                        }}
                                    />
                                    <Button
                                        template="searchReset"
                                        onClick={(e) => {
                                            handleSearchReset(e);
                                        }}
                                    />
                                </div>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </>
    );
};
export default StakeholderVehicleTypeSearch;
